import React from 'react';
import PropTypes from 'prop-types';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { itemStyle } from './styles/placements-function-target-styles';

export const CheckOOInventoryBlocklists = ({
  i18n,
}) => (
  <CampaignOData
    call={({ currentAccount }) => currentAccount.PlacementExclusionLists['Default.GetOwnedOperatedExclusions'].get()}
  >
    {oolist => (
           oolist.value.length > 0 &&
           <MessageBar
             id="placements-target-message-bar"
             messageBarType={MessageBarType.severeWarning}
             isMultiline
             styles={itemStyle}
             className="targets-message-bar"
           >
             {i18n.getString(_TL_('You may be excluding the following websites which will prevent your campaign from serving'))}: { oolist.value.map(item => item.Url).join(', ')}
           </MessageBar>
                   )
        }
  </CampaignOData>
);

CheckOOInventoryBlocklists.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
